module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"protrusion-role":{"SELLER":"Seller","STUD":"Stud","BROKER":"Broker","UNKNOWN":"Other"}}}')
  delete Component.options._Ctor
}
